export const mockMovies = [
  {
    id: 1,
    title: "Stranger Things",
    type: "tv",
    description: "When a young boy vanishes, a small town uncovers a mystery involving secret experiments, terrifying supernatural forces and one strange little girl.",
    genre: ["Drama", "Fantasy", "Horror"],
    rating: "TV-14",
    year: 2016,
    duration: "51 min",
    thumbnailUrl: "https://image.tmdb.org/t/p/w300/49WJfeN0moxb9IPfGn8AIqMGskD.jpg",
    bannerUrl: "https://image.tmdb.org/t/p/w1920_and_h800_multi_faces/49WJfeN0moxb9IPfGn8AIqMGskD.jpg",
    trailerUrl: "https://www.youtube.com/embed/b9EkMc79ZSU",
    cast: ["Millie Bobby Brown", "Finn Wolfhard", "Winona Ryder"],
    episodes: 34,
    seasons: 4,
    featured: true,
    watchseriesUrl: "https://watchseries.bar/tv/stranger-things/66732",
    imdbRating: 8.7,
    tmdbRating: 8.5
  },
  {
    id: 2,
    title: "The Dark Knight",
    type: "movie",
    description: "Batman raises the stakes in his war on crime. With the help of Lt. Jim Gordon and District Attorney Harvey Dent, Batman sets out to dismantle the remaining criminal organizations that plague Gotham.",
    genre: ["Action", "Crime", "Drama"],
    rating: "PG-13",
    year: 2008,
    duration: "152 min",
    thumbnailUrl: "https://image.tmdb.org/t/p/w300/qJ2tW6WMUDux911r6m7haRef0WH.jpg",
    bannerUrl: "https://image.tmdb.org/t/p/w1920_and_h800_multi_faces/qJ2tW6WMUDux911r6m7haRef0WH.jpg",
    trailerUrl: "https://www.youtube.com/embed/EXeTwQWrcwY",
    cast: ["Christian Bale", "Heath Ledger", "Aaron Eckhart"],
    featured: false,
    watchseriesUrl: "https://watchseries.bar/movie/the-dark-knight/2",
    imdbRating: 9.0,
    tmdbRating: 8.5
  },
  {
    id: 3,
    title: "The Crown",
    type: "tv",
    description: "This drama follows the political rivalries and romance of Queen Elizabeth II's reign and the events that shaped the second half of the 20th century.",
    genre: ["Biography", "Drama", "History"],
    rating: "TV-MA",
    year: 2016,
    duration: "58 min",
    thumbnailUrl: "https://image.tmdb.org/t/p/w300/4Sp5sRySWAki5M5VNXr4DYKV7FT.jpg",
    bannerUrl: "https://image.tmdb.org/t/p/w1920_and_h800_multi_faces/4Sp5sRySWAki5M5VNXr4DYKV7FT.jpg",
    trailerUrl: "https://www.youtube.com/embed/JWtnJjn6ng0",
    cast: ["Claire Foy", "Olivia Colman", "Helena Bonham Carter"],
    episodes: 40,
    seasons: 4,
    featured: false,
    watchseriesUrl: "https://watchseries.bar/tv/the-crown/3",
    imdbRating: 8.6,
    tmdbRating: 8.2
  },
  {
    id: 4,
    title: "Inception",
    type: "movie",
    description: "A thief who enters the dreams of others to steal secrets from their subconscious gets the chance to regain his old life as payment for a task considered impossible.",
    genre: ["Action", "Sci-Fi", "Thriller"],
    rating: "PG-13",
    year: 2010,
    duration: "148 min",
    thumbnailUrl: "https://image.tmdb.org/t/p/w300/9gk7adHYeDvHkCSEqAvQNLV5Uge.jpg",
    bannerUrl: "https://image.tmdb.org/t/p/w1920_and_h800_multi_faces/9gk7adHYeDvHkCSEqAvQNLV5Uge.jpg",
    trailerUrl: "https://www.youtube.com/embed/YoHD9XEInc0",
    cast: ["Leonardo DiCaprio", "Marion Cotillard", "Tom Hardy"],
    featured: false,
    watchseriesUrl: "https://watchseries.bar/movie/inception/4",
    imdbRating: 8.8,
    tmdbRating: 8.3
  },
  {
    id: 5,
    title: "Breaking Bad",
    type: "tv",
    description: "A high school chemistry teacher diagnosed with inoperable lung cancer turns to manufacturing and selling methamphetamine to secure his family's future.",
    genre: ["Crime", "Drama", "Thriller"],
    rating: "TV-MA",
    year: 2008,
    duration: "47 min",
    thumbnailUrl: "https://image.tmdb.org/t/p/w300/ggFHVNu6YYI5L9pCfOacjizRGt.jpg",
    bannerUrl: "https://image.tmdb.org/t/p/w1920_and_h800_multi_faces/ggFHVNu6YYI5L9pCfOacjizRGt.jpg",
    trailerUrl: "https://www.youtube.com/embed/HhesaQXLuRY",
    cast: ["Bryan Cranston", "Aaron Paul", "Anna Gunn"],
    episodes: 62,
    seasons: 5,
    featured: true,
    watchseriesUrl: "https://watchseries.bar/tv/breaking-bad/5",
    imdbRating: 9.5,
    tmdbRating: 8.9
  },
  {
    id: 6,
    title: "Avengers: Endgame",
    type: "movie",
    description: "After the devastating events of Infinity War, the Avengers assemble once more to reverse Thanos' actions and restore balance to the universe.",
    genre: ["Action", "Adventure", "Drama"],
    rating: "PG-13",
    year: 2019,
    duration: "181 min",
    thumbnailUrl: "https://image.tmdb.org/t/p/w300/or06FN3Dka5tukK1e9sl16pB3iy.jpg",
    bannerUrl: "https://image.tmdb.org/t/p/w1920_and_h800_multi_faces/or06FN3Dka5tukK1e9sl16pB3iy.jpg",
    trailerUrl: "https://www.youtube.com/embed/TcMBFSGVi1c",
    cast: ["Robert Downey Jr.", "Chris Evans", "Scarlett Johansson"],
    featured: false,
    watchseriesUrl: "https://watchseries.bar/movie/avengers-endgame/6",
    imdbRating: 8.4,
    tmdbRating: 8.2
  },
  {
    id: 7,
    title: "The Witcher",
    type: "tv",
    description: "Geralt of Rivia, a solitary monster hunter, struggles to find his place in a world where people often prove more wicked than beasts.",
    genre: ["Action", "Adventure", "Drama"],
    rating: "TV-MA",
    year: 2019,
    duration: "60 min",
    thumbnailUrl: "https://image.tmdb.org/t/p/w300/7vjaCdMw15FEbXyLQTVa04URsPm.jpg",
    bannerUrl: "https://image.tmdb.org/t/p/w1920_and_h800_multi_faces/7vjaCdMw15FEbXyLQTVa04URsPm.jpg",
    trailerUrl: "https://www.youtube.com/embed/ndl1W4ltcmg",
    cast: ["Henry Cavill", "Anya Chalotra", "Freya Allan"],
    episodes: 16,
    seasons: 2,
    featured: false,
    watchseriesUrl: "https://watchseries.bar/tv/the-witcher/7",
    imdbRating: 8.2,
    tmdbRating: 8.0
  },
  {
    id: 8,
    title: "Interstellar",
    type: "movie",
    description: "A team of explorers travel through a wormhole in space in an attempt to ensure humanity's survival.",
    genre: ["Adventure", "Drama", "Sci-Fi"],
    rating: "PG-13",
    year: 2014,
    duration: "169 min",
    thumbnailUrl: "https://image.tmdb.org/t/p/w300/gEU2QniE6E77NI6lCU6MxlNBvIx.jpg",
    bannerUrl: "https://image.tmdb.org/t/p/w1920_and_h800_multi_faces/gEU2QniE6E77NI6lCU6MxlNBvIx.jpg",
    trailerUrl: "https://www.youtube.com/embed/zSWdZVtXT7E",
    cast: ["Matthew McConaughey", "Anne Hathaway", "Jessica Chastain"],
    featured: false,
    watchseriesUrl: "https://watchseries.bar/movie/interstellar/8",
    imdbRating: 8.6,
    tmdbRating: 8.1
  },
  {
    id: 9,
    title: "Money Heist",
    type: "tv",
    description: "An unusual group of robbers attempt to carry out the most perfect robbery in Spanish history - stealing 2.4 billion euros from the Royal Mint of Spain.",
    genre: ["Action", "Crime", "Mystery"],
    rating: "TV-MA",
    year: 2017,
    duration: "70 min",
    thumbnailUrl: "https://image.tmdb.org/t/p/w300/MoEKaPFHABtA1xKoOteirGaHl1.jpg",
    bannerUrl: "https://image.tmdb.org/t/p/w1920_and_h800_multi_faces/MoEKaPFHABtA1xKoOteirGaHl1.jpg",
    trailerUrl: "https://www.youtube.com/embed/_InqQJRqGW4",
    cast: ["Álvaro Morte", "Itziar Ituño", "Pedro Alonso"],
    episodes: 41,
    seasons: 5,
    featured: true,
    watchseriesUrl: "https://watchseries.bar/tv/money-heist/9",
    imdbRating: 8.3,
    tmdbRating: 8.1
  },
  {
    id: 10,
    title: "The Godfather",
    type: "movie",
    description: "The aging patriarch of an organized crime dynasty transfers control of his clandestine empire to his reluctant son.",
    genre: ["Crime", "Drama"],
    rating: "R",
    year: 1972,
    duration: "175 min",
    thumbnailUrl: "https://image.tmdb.org/t/p/w300/3bhkrj58Vtu7enYsRolD1fZdja1.jpg",
    bannerUrl: "https://image.tmdb.org/t/p/w1920_and_h800_multi_faces/3bhkrj58Vtu7enYsRolD1fZdja1.jpg",
    trailerUrl: "https://www.youtube.com/embed/sY1S34973zA",
    cast: ["Marlon Brando", "Al Pacino", "James Caan"],
    featured: false,
    watchseriesUrl: "https://watchseries.bar/movie/the-godfather/10",
    imdbRating: 9.2,
    tmdbRating: 8.7
  }
];

export const categories = {
  trending: [1, 5, 9, 3, 7],
  action: [2, 4, 6, 8],
  drama: [1, 3, 5, 10],
  sciFi: [4, 6, 8],
  crime: [2, 5, 9, 10],
  tvShows: [1, 3, 5, 7, 9],
  movies: [2, 4, 6, 8, 10],
  newReleases: [7, 6, 9],
  topRated: [2, 4, 5, 10],
  continueWatching: [1, 5, 7]
};

export const profiles = [
  {
    id: 1,
    name: "John",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    isKids: false,
    watchlist: [1, 3, 5],
    continueWatching: [
      { contentId: 1, progress: 45, lastWatched: "2023-10-15" },
      { contentId: 5, progress: 78, lastWatched: "2023-10-14" }
    ],
    customSections: []
  },
  {
    id: 2,
    name: "Sarah",
    avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
    isKids: false,
    watchlist: [2, 4, 6],
    continueWatching: [
      { contentId: 3, progress: 23, lastWatched: "2023-10-13" }
    ],
    customSections: []
  },
  {
    id: 3,
    name: "Kids",
    avatar: "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=150&h=150&fit=crop&crop=face",
    isKids: true,
    watchlist: [],
    continueWatching: [],
    customSections: []
  },
  {
    id: 4,
    name: "Mike",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    isKids: false,
    watchlist: [7, 8, 9],
    continueWatching: [
      { contentId: 9, progress: 67, lastWatched: "2023-10-16" }
    ],
    customSections: []
  }
];

export const getContentById = (id) => {
  return mockMovies.find(item => item.id === id);
};

export const getContentByIds = (ids) => {
  return ids.map(id => getContentById(id)).filter(Boolean);
};

export const searchContent = (query) => {
  if (!query) return [];
  const lowercaseQuery = query.toLowerCase();
  return mockMovies.filter(item =>
    item.title.toLowerCase().includes(lowercaseQuery) ||
    item.genre.some(g => g.toLowerCase().includes(lowercaseQuery)) ||
    item.cast.some(actor => actor.toLowerCase().includes(lowercaseQuery))
  );
};